module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/va-555e01bd279c6bbc28c4b4bd85a47582.svg";